// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  [id^='userpilot'],
  #userpilotContent--CSnzi {
    display: none !important;
    visibility: hidden !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/common/styles/userpilot.css"],"names":[],"mappings":"AAAA;EACE;;IAEE,wBAAwB;IACxB,6BAA6B;EAC/B;AACF","sourcesContent":["@media print {\n  [id^='userpilot'],\n  #userpilotContent {\n    display: none !important;\n    visibility: hidden !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var userpilotContent = `userpilotContent--CSnzi`;
export default ___CSS_LOADER_EXPORT___;
